import React, { useState } from "react";
import { Check, Copy, X } from "lucide-react";

function CopyField({ label, value, displayValue }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="text-left">
      <p className="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">
        {label}
      </p>
      <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5">
        <span className="flex-1 truncate text-sm text-gray-800">
          {displayValue || value}
        </span>
        <button
          type="button"
          onClick={handleCopy}
          className="rounded p-1 text-gray-500 hover:bg-white hover:text-gray-800"
          title="Copy"
        >
          {copied ? (
            <Check className="h-4 w-4 text-green-600" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </button>
      </div>
    </div>
  );
}

export default function PublishSuccessModal({ open, form, onClose }) {
  if (!open || !form) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="relative w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-md p-1 text-gray-400 hover:bg-gray-100"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-500">
          <Check className="h-7 w-7 text-white" strokeWidth={3} />
        </div>

        <h2 className="text-lg font-semibold text-[#1D2739]">
          {form.name} successfully created
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          Your form is now live and ready to be shared
        </p>

        <div className="mt-6 space-y-4">
          <CopyField label="API Key" value={form.apiKey} displayValue={`${form.apiKey?.slice(0, 16)}...`} />
          <CopyField label="Public URL" value={form.publicUrl} />
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-[#EAF524] px-8 py-2.5 text-sm font-semibold text-black hover:bg-[#e0eb1f]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
